export default __webpack_public_path__ + "static/media/ximen.95129d67.jpg";